import React from 'react';
import { Flex, Typography } from 'antd';
import { Link } from 'react-router-dom';

import { StepTitle } from '../../steps/StepTitle';
import { StepList } from '../../steps/StepList';

const { Text } = Typography;

export const YookassaStepInit = () => {
    return (
        <Flex vertical gap={8}>
            <StepTitle text={'Шаг 1 Регистрация в Юкасса'} />

            <StepList>
                <Text>Для подключения оплаты необходимо:</Text>
                <Text>
                    1. перейти по{' '}
                    <Link
                        target={'_blank'}
                        to={
                            'https://yookassa.ru/yooid/signup/step/phone?origin=Checkout'
                        }
                    >
                        {' '}
                        партнерской ссылке
                    </Link>{' '}
                    и зарегистрироваться
                </Text>
                <Text>2. создать магазин в системе Юкасса</Text>
            </StepList>
        </Flex>
    );
};
